import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { getStickyChildStyle, getStickyContainerStyle, STICKY_OPTIONS_KEYS, } from './stickyEmulation';
import { useSticky } from './useSticky';
import { useForkRef } from '../../hooks/useForkRef';
import { omitKeys } from '../../utils/object';
/**
 * The compatibility component for older versions of Sticky. This is provided
 * because there are more than 60 instances of Sticky in the codebase, and it is
 * not possible to convert them one by one.
 * However, please do note that this only tries to match the observed behavior
 * in the ohou.se-client.
 *
 * Furthermore, offset functions, for example, offset={() => {}} is omitted
 * because it is fundamentally incompatible from current Sticky design, and it
 * is not possible to make escape hatch for it.
 * Instead, we provide ScrollStickyCompat for exactly this purpose, so please
 * use that instead.
 * @deprecated Please convert this to Sticky, as this is only provided for
 *   compatibility reasons.
 */
export function StickyCompat(props) {
    const { className, enabledClassName, innerClassName, children, containerRef, innerRef, onEnabledChange, containerStyle, style, initialState, ...restProps } = omitKeys(props, STICKY_OPTIONS_KEYS);
    const containerStickyRef = useRef(null);
    const containerForkRef = useForkRef(containerRef, containerStickyRef);
    const childStickyRef = useRef(null);
    const childForkRef = useForkRef(innerRef, childStickyRef);
    // disabled can receive both function and boolean; defer it if it's function
    const { disabled: disabledProp } = props;
    const [disabledState, setDisabled] = useState(true);
    const disabled = 
    // eslint-disable-next-line react/destructuring-assignment
    typeof disabledProp === 'function' ? disabledState : disabledProp;
    const stickyOptions = { ...props, disabled };
    const stickyState = useSticky(stickyOptions, containerStickyRef, childStickyRef, initialState);
    useEffect(() => {
        if (onEnabledChange != null) {
            onEnabledChange(stickyState.emulatedDisabled);
        }
    }, [onEnabledChange, stickyState.emulatedDisabled]);
    useEffect(() => {
        if (typeof disabledProp === 'function') {
            setDisabled(disabledProp());
        }
    }, [disabledProp]);
    return (React.createElement("div", { className: classNames('sticky-container', !stickyState.emulatedDisabled && enabledClassName, className), style: {
            ...getStickyContainerStyle(stickyState, stickyOptions),
            ...containerStyle || {},
        }, ref: containerForkRef },
        React.createElement("div", Object.assign({}, restProps, { className: classNames('sticky-child', innerClassName), style: {
                ...getStickyChildStyle(stickyState, stickyOptions),
                ...style || {},
            }, ref: childForkRef }), children)));
}
//# sourceMappingURL=StickyCompat.js.map